import { Injectable } from '@angular/core';
import { StorageEngine } from '@ngxs/storage-plugin';
import { REMEMBER_ME_STATUS_KEY } from '~backoffice/app/~shared/constants/global.constants';

@Injectable()
export class CustomNgxsStorageEngine implements StorageEngine {
  get length(): number {
    if (isRememberMeStatusSet()) {
      return localStorage.length;
    } else {
      return sessionStorage.length;
    }
  }

  getItem(key: string): string | null {
    if (isRememberMeStatusSet()) {
      return localStorage.getItem(key);
    } else {
      return sessionStorage.getItem(key);
    }
  }

  setItem(key: string, val: string): void {
    if (isRememberMeStatusSet()) {
      localStorage.setItem(key, val);
    } else {
      sessionStorage.setItem(key, val);
    }
  }

  removeItem(key: string): void {
    if (isRememberMeStatusSet()) {
      localStorage.removeItem(key);
    } else {
      sessionStorage.removeItem(key);
    }
  }

  clear(): void {
    if (isRememberMeStatusSet()) {
      localStorage.clear();
    } else {
      sessionStorage.clear();
    }
  }
}

export const setRememberMeStatus = (set: boolean): void => {
  set
    ? localStorage.setItem(REMEMBER_ME_STATUS_KEY, 'true')
    : localStorage.removeItem(REMEMBER_ME_STATUS_KEY);
};

export const isRememberMeStatusSet = (): boolean => {
  return !!localStorage.getItem(REMEMBER_ME_STATUS_KEY);
};
